import { timeline } from "@/mocks/loveHelperData";

export default function TimelineSection() {
  return (
    <section id="timeline" className="mx-auto max-w-7xl px-4 py-16 md:py-20 md:px-6">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <span className="text-sm font-semibold text-primary-600">感情线时间轴</span>
          <h2 className="mt-2 text-2xl font-bold text-foreground-900 md:text-4xl">
            恋爱辅助器感情线全梳理
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            从相遇冤家到双向奔赴，按章节把主线感情线拆解成五个阶段。每一阶段都是一次心动升级，跟着时间轴一路看下来，人物关系自然就清晰了。
          </p>
          <div className="mt-6 hidden items-center gap-3 rounded-lg bg-secondary-100 p-4 lg:flex">
            <i className="ri-sparkling-line text-xl text-secondary-700"></i>
            <p className="text-sm text-secondary-900">
              小贴士：先看「相遇」和「双向奔赴」两段，最快抓住感情线核心走向。
            </p>
          </div>
        </div>

        <div className="lg:col-span-8">
          <ol className="relative ml-3 border-l-2 border-primary-200 pl-8">
            {timeline.map((t, i) => (
              <li key={t.chapter} className="relative pb-10 last:pb-0">
                <span className="absolute -left-[41px] top-1 flex h-5 w-5 items-center justify-center rounded-full border-2 border-background-50 bg-primary-500">
                  <span className="h-1.5 w-1.5 rounded-full bg-background-50"></span>
                </span>
                <div className="flex flex-wrap items-center gap-3">
                  <span className="rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-800">
                    {t.chapter}
                  </span>
                  <h3 className="text-lg font-bold text-foreground-900">{t.title}</h3>
                </div>
                <p className="mt-2 max-w-xl text-sm leading-relaxed text-foreground-600">
                  {t.desc}
                </p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}